import type { AxiosResponse } from "axios";
import type { ApiResponse } from "@/types/common";
import { privateRequest } from "../axios";

export interface LanguageOption {
  id: number | string;
  languageCode: string;
  languageName: string;
  translations: Record<string, string> | null;
}

const ENDPOINTS = {
  LANGUAGE: "/language",
};

const getLanguages = async (): Promise<ApiResponse<LanguageOption[]>> => {
  const response: AxiosResponse<ApiResponse<LanguageOption[]>> =
    await privateRequest.get(ENDPOINTS.LANGUAGE);
  return response.data;
};

const getLanguageByCode = async (
  languageCode: string,
): Promise<ApiResponse<LanguageOption>> => {
  const response: AxiosResponse<ApiResponse<LanguageOption>> =
    await privateRequest.get(`${ENDPOINTS.LANGUAGE}/${languageCode}`);
  return response.data;
};

const LanguageService = {
  getLanguages,
  getLanguageByCode,
};

export { getLanguages, getLanguageByCode };
export default LanguageService;
